import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const [meetingsOpen, setMeetingsOpen] = useState(true);
  const [tasksOpen, setTasksOpen] = useState(true);

  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <ul className="nav sidebar-menu flex-column">
      {/* Dashboard */}
      <li className={`nav-item ${isActive("/overseer/dashboard") ? "active" : ""}`}>
        <Link to="/overseer/dashboard" className="nav-link">
          <i className="nav-icon bi bi-speedometer"></i>
          <p>Dashboard</p>
        </Link>
      </li>

      {/* Live Chat */}
      <li className={`nav-item ${isActive("/overseer/live-chat") ? "active" : ""}`}>
        <Link to="/overseer/live-chat" className="nav-link">
          <i className="nav-icon bi bi-chat-dots"></i>
          <p>Live Chat</p>
        </Link>
      </li>

      {/* Manage Guest */}
      <li className={`nav-item ${isActive("/overseer/guest-management/guest") ? "active" : ""}`}>
        <Link to="/overseer/guest-management/guest" className="nav-link">
          <i className="nav-icon bi bi-people"></i>
          <p>Manage Guest</p>
        </Link>
      </li>

      {/* Drug Screening Results */}
      <li className={`nav-item ${isActive("/overseer/drug-screening-result/list") ? "active" : ""}`}>
        <Link to="/overseer/drug-screening-result/list" className="nav-link">
          <i className="nav-icon bi bi-capsule-pill"></i>
          <p>Drug Screening Result</p>
        </Link>
      </li>

      {/* Meetings */}
      <li className={`nav-item ${meetingsOpen ? "menu-open" : ""}`}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setMeetingsOpen(!meetingsOpen);
          }}
          className="nav-link"
        >
          <i className="nav-icon bi bi-calendar-event"></i>
          <p>
            Meetings
            <i
              className={`right bi ${
                meetingsOpen ? "bi-chevron-up" : "bi-chevron-down"
              } ms-2`}
            ></i>
          </p>
        </a>

        {meetingsOpen && (
          <ul className="nav nav-treeview ps-3">
            <li
              className={`nav-item ${
                isActive("/overseer/meetings/create") ? "active" : ""
              }`}
            >
              <Link to="/overseer/meetings/create" className="nav-link">
                <i className="bi bi-plus-circle nav-icon"></i>
                <p>Create Meeting</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                isActive("/overseer/meetings/list") ? "active" : ""
              }`}
            >
              <Link to="/overseer/meetings/list" className="nav-link">
                <i className="bi bi-list-ul nav-icon"></i>
                <p>Manage Meeting</p>
              </Link>
            </li>
          </ul>
        )}
      </li>

      {/* Tasks */}
      <li className={`nav-item ${tasksOpen ? "menu-open" : ""}`}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setTasksOpen(!tasksOpen);
          }}
          className="nav-link"
        >
          <i className="nav-icon bi bi-list-task"></i>
          <p>
            Tasks
            <i
              className={`right bi ${
                tasksOpen ? "bi-chevron-up" : "bi-chevron-down"
              } ms-2`}
            ></i>
          </p>
        </a>

        {tasksOpen && (
          <ul className="nav nav-treeview ps-3">
            <li
              className={`nav-item ${
                isActive("/overseer/tasks/create") ? "active" : ""
              }`}
            >
              <Link to="/overseer/tasks/create" className="nav-link">
                <i className="bi bi-plus-circle nav-icon"></i>
                <p>Create Task</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                isActive("/overseer/tasks/list") ? "active" : ""
              }`}
            >
              <Link to="/overseer/tasks/list" className="nav-link">
                <i className="bi bi-list-ul nav-icon"></i>
                <p>Manage Task</p>
              </Link>
            </li>
          </ul>
        )}
      </li>

      {/* E-sign Consent Form */}
      <li className={`nav-item ${isActive("/overseer/sign-consent/view") ? "active" : ""}`}>
        <Link to="/overseer/sign-consent/view" className="nav-link">
          <i className="nav-icon bi bi-pencil-square"></i>
          <p>E-sign Consent Form</p>
        </Link>
      </li>
    </ul>
  );
};

export default Sidebar;
